import { IHeaderAngularComp } from 'ag-grid-angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'vle-group-header-renderer',
  templateUrl: 'group-header-cell-renderer.component.html',
  styleUrls: ['group-header-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupHeaderCellRenderer implements IHeaderAngularComp {
  params!: IHeaderParams;
  isExpand: Observable<boolean>;

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.isExpand = this.params.context.componentParent.$openGroupIds.pipe(map((items: string[]) => items.length > 0));
  }

  refresh(params: IHeaderParams): boolean {
    return true;
  }

  onExpandButtonClick(isExpand: boolean): void {
    const { context, api } = this.params;

    api.forEachNode(node => {
      if (isExpand) {
        context.componentParent.removeChildRow(node);
      } else {
        context.componentParent.addChildRow(node);
      }
    });

    context.componentParent.onAllRowExpandToggle(!isExpand);
  }
}
